export default __webpack_public_path__ + "static/media/login.9d1a04ea0542917ac7fe72f524d6bfb6.png";